export default __webpack_public_path__ + "static/media/START_Shredder.c5392fca.pdf";